import script from "./ArticleContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./ArticleContent.vue?vue&type=script&setup=true&lang=ts"

import "./ArticleContent.vue?vue&type=style&index=0&id=a0b7c286&lang=scss"

const __exports__ = script;

export default __exports__